import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import InputTel from 'Components/Atoms/InputTel/InputTel';

export default function RHFInputTel({ name, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <InputTel name={name} {...field} error={error?.message} {...other} />
            )}
        />
    );
}

RHFInputTel.propTypes = {
    name: PropTypes.string,
};
